import { useCustomMutation } from "@refinedev/core";
import { notification } from "antd";
import { SUBMIT_PURCHASE_ORDER_MUTATION } from "../queries";

interface SubmitPurchaseOrderResponse {
  id: string;
  orderNo: string;
  status: string;
  approvals: Array<{
    order: number;
    roleSlug: string;
    stepName?: string;
    stepStatus: string;
  }>;
  totalAmount: number;
  approvalType?: string;
  steps?: Array<{
    order: number;
    roleSlug: string;
    stepName?: string;
  }>;
  externalWorkflow?: Record<string, any>;
  approvalData?: any;
  flowCaseId?: string;
  flowCaseNumber?: string;
  submittedBy?: string;
}

interface UseSubmitPurchaseOrderProps {
  onSuccess?: (data: SubmitPurchaseOrderResponse) => void;
  onError?: (error: any) => void;
}

export const useSubmitPurchaseOrder = ({
  onSuccess,
  onError
}: UseSubmitPurchaseOrderProps = {}) => {
  const { mutate: submitPurchaseOrder, isLoading } = useCustomMutation<SubmitPurchaseOrderResponse>();

  const submit = async (input: { orderId?: string; orderData?: any; fiscalYear: number }) => {
    try {
      const values = {
        input: {
          orderId: input.orderId,
          orderData: input.orderData,
          fiscalYear: input.fiscalYear
        }
      };

      submitPurchaseOrder({
        meta: {
          gqlMutation: SUBMIT_PURCHASE_ORDER_MUTATION,
        },
        values: values,
        url: "",
        method: "post"
      }, {
        onSuccess: (data) => {
          const response = (data as any)?.data?.submitPurchaseOrder || data;

          notification.success({
            message: 'Purchase Order Submitted Successfully',
            description: 'The purchase order has been submitted for approval.',
          });
          onSuccess?.(response);
        },
        onError: (error) => {
          notification.error({
            message: 'Submission Failed',
            description: error.message || 'Failed to submit the purchase order.',
          });
          onError?.(error);
        }
      });
    } catch (error) {
      console.error('Error submitting purchase order:', error);
      onError?.(error);
    }
  };

  return {
    submit,
    isLoading
  };
};